import classNames from 'classnames';
import { useRef } from 'react';

import { Image } from '../../Image';
import Tooltip from '../../Tooltip';
import { VariantIconSvg } from './VariantIconSvg';

type Props = {
  active?: boolean;
  backgroundColours?: string[];
  crossedOut?: boolean;
  diameter?: number;
  disabled?: boolean;
  text?: string;
  thumbnail?: string;
  tooltipText: string;
  textStyle?: 'light' | 'dark';
};

export const VariantIcon: React.FC<Props> = ({
  active = false,
  backgroundColours = ['#F9F6F4'],
  crossedOut = false,
  diameter = 36,
  disabled = false,
  text,
  textStyle = 'dark',
  thumbnail = undefined,
  tooltipText,
}) => {
  const parentRef = useRef<HTMLDivElement>(null);
  const selectionRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={parentRef} aria-label={tooltipText}>
      <div
        ref={selectionRef}
        className={classNames('group', {
          'cursor-not-allowed opacity-50': disabled,
          'cursor-pointer opacity-100': !disabled,
        })}
      >
        <div className="relative" style={{ width: diameter, height: diameter }}>
          {thumbnail ? (
            <div
              className={classNames(
                'inset-0 rounded-full border-2 transition-all duration-300',
                {
                  'border-neutral-6': active,
                  'border-neutral-2': !active,
                  'group-hover:border-neutral-4': !active && !disabled,
                },
              )}
            >
              <div className="rounded-full border-2 border-white">
                <Image
                  alt={tooltipText}
                  shape="circle"
                  src={thumbnail}
                  width={64}
                />
              </div>
            </div>
          ) : (
            <VariantIconSvg
              active={active}
              backgroundColours={backgroundColours}
              crossedOut={crossedOut}
              diameter={diameter}
              disabled={disabled}
              text={text}
              textStyle={textStyle}
            />
          )}
        </div>
      </div>

      <Tooltip parentRef={parentRef} selectionRef={selectionRef}>
        {tooltipText}
      </Tooltip>
    </div>
  );
};
